import moment from 'moment/moment';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {getConfig} from '../../../util/configUtil';
import Chip from '@mui/material/Chip';
import makeStyles from '@mui/styles/makeStyles';
import {useTheme} from '@mui/material/styles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
    chipAttendance: {
        backgroundColor: theme.palette.mode === 'light' ? '#eff1f3' : '#ffffff',
        color: '#222222',
        fontWeight: 'bold',
        minWidth: 300,
        minHeight: 32,
        justifyContent: 'start',
        '& .MuiChip-avatar': {
            marginLeft: '0 10px',
        },
        '& .MuiChip-label': {
            width: '100%',
        },
        '&.selected': {
            backgroundColor: theme.palette.primary.main,
        },
        '&.selectable': {
            '&:hover': {
                cursor: 'pointer',
                backgroundColor: theme.palette.primary.light,
            },
        },
    },
    attendanceType: {
        width: '16px !important',
        height: '16px !important',
        borderRadius: '50%',
    },
}));

const AttendanceChip = ({
                            admission,
                            classesOverride,
                            reviewCtx,
                            onClick,
                            selectable = false,
                            selected = false,
                            showVisitNumber = false,
                        }) => {
    const classes = useStyles();
    const theme = useTheme();

    const {t} = useTranslation();

    // Config
    const dateFormat = getConfig('defaultDateTimeFormat');


    let color, text;
    if (reviewCtx) {
        color = '#555a95';
        text = t('From Patient Review');
    } else {
        switch (admission?.attendanceType) {
            case 'E':
                color = theme.palette.attendanceType.ed;
                text = t('Emergency Department');
                break;
            case 'I':
                color = theme.palette.attendanceType.ip;
                text = t('Inpatient');
                break;
            case 'O':
                color = theme.palette.attendanceType.op;
                text = t('Outpatient');
                break;
            default:
                console.warn('Wrong attendance type', admission);
                color = '#222222';
                text = 'UNK';
                break;
        }
    }

    const getAttendanceType = () => {
        return <div className={classes.attendanceType} style={{backgroundColor: color}}/>;
    };

    const handleShowVisitNumber = () => {
        if (showVisitNumber) {
            return `(${admission?.attendanceId || '-'})`;
        }

        return null;
    };

    return (
        <Chip
            className={clsx(
                classes.chipAttendance,
                selected && 'selected',
                selectable && 'selectable',
                classesOverride,
            )}
            onClick={selectable ? onClick : undefined}
            avatar={getAttendanceType()}
            label={
                <span style={{width: '100%'}}>
                    {`${text} ${reviewCtx ? '' : moment(admission?.startDate).format(dateFormat)}`}
                    <span style={{float: 'right', fontSize: 12}}> {handleShowVisitNumber()}</span>
                </span>
            }
        />
    );
};

export default AttendanceChip;